import React, { useState } from 'react';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import * as ReactUI from 'react-bootstrap';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import {
  backgroundThemeState,
  contactButtonHoverState,
  darkModeState,
} from '../../atoms';
import { projects } from '../../data';
import { appWrapper } from '../../hoc';
import { useContactButtonHover, useHover } from '../../util/hooks';
import './styles.scss';

function Projects() {
  const [show, setShow] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const background = useRecoilValue(backgroundThemeState);
  const setContactButtonHoverState = useSetRecoilState(contactButtonHoverState);
  useContactButtonHover(background, '.preview');

  const darkMode = useRecoilValue(darkModeState);
  const { hover } = useHover();

  const handleShow = (image: string, bg: string) => {
    setShow(true);
    setImageUrl(image);
  };

  const closeShow = () => {
    setShow(false);
    setImageUrl('');
  };

  React.useEffect(() => {
    setContactButtonHoverState(background);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id="main-row">
      {show && (
        <div id="preview" className="preview">
          <AnimationOnScroll className={'animate__fadeInLeftBig'}>
            <ReactUI.Image
              className="img"
              src={imageUrl}
              width={550}
              height={500}
            />
          </AnimationOnScroll>
        </div>
      )}

      <div style={{ marginLeft: 'auto' }}>
        {projects.map((project) => (
          <div key={project.className} className="d-flex">
            <AnimationOnScroll
              style={{ marginLeft: 'auto' }}
              className={'animate__fadeInLeftBig'}
            >
              <a
                href={project.link}
                id={project.name}
                onMouseEnter={() => {
                  handleShow(project.logo, project.bg);
                  hover(project);
                }}
                onMouseLeave={closeShow}
                key={project.className}
                className={
                  !darkMode ? project.className : project.classNameDark
                }
              >
                {project.name}
              </a>
            </AnimationOnScroll>
          </div>
        ))}
      </div>
    </div>
  );
}

export default appWrapper(Projects, 'projects');
